module.exports = "/images/party software center.svg?c9c8466d79a5e02e9bef0c4ca84555bc";